
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-a-loan",
      function () {
        return require("private-next-pages/get-a-loan.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-a-loan"])
      });
    }
  